/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Mixins,
  Watch,
  Prop,
} from 'vue-property-decorator';
import { Icon } from 'vant';
import { Toast } from '@hb/coffee';
import { namespace } from 'vuex-class';
import AlipayMixins from '@/mixins/alipay';
import { CardBindTypeEnum } from '@/api/apply-product/types';
import type { ApplyChannelData } from '@/api/apply-product/types';
import { YINHE_COMMODITY } from '@/shared/commodity';
import { paySignCenterAlipay, signWithoutPasswordContract } from '@/api/native/aliMP';
import platform from '@/shared/utils/platform';
import FormField from '@/components/form-field';
import { SceneTypeEnum } from '@/enums/scene-type';
import { alipayOptions } from './until';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

// 借款场景下
@Component({ name: 'SelectAlipay' })
export default class SelectAlipay extends Mixins(AlipayMixins) {
  @ApplyProductStore.State channel!: ApplyChannelData;

  @ApplyProductStore.State alipaySignData!: {
    serialNumber: string;
    signUrl: string;
  };

  @ApplyProductStore.State iSalipaySignSuccess!: boolean;

  @ApplyProductStore.State payType!: CardBindTypeEnum;

  @ApplyProductStore.Getter isSimplifiedListStyle!: boolean;

  // 查询签约状态
  @ApplyProductStore.Action checkAlipayStatus!: () => Promise<void>;

  private get commidityId(): string {
    return this.channel && this.channel.productId;
  }

  /** 支付宝签约场景 */
  private get isAlipayType() {
    return this.payType === CardBindTypeEnum.ALIPAY;
  }

  private get alipaySignStatus() {
    return this.isAlipayType ? this.getAlipayStatus : this.iSalipaySignSuccess;
  }

  @Watch('commidityId', { immediate: true })
  private async onChange() {
    await this.getCheckStatus();
  }

  // 新老银河的查询状态
  private async getCheckStatus() {
    if (this.isAlipayType) {
      const params = {
        scene: SceneTypeEnum.LOAN,
        creditApplyId: this.channel.creditApplyId,
      };
      await this.checkAlipay(params);
    } else {
      await this.checkAlipayStatus();
    }
  }

  // 签约支付宝sdk
  private onSigningAlipay() {
    this.$ubtPageButton(
      'finance_applyProductAlipay',
      '时间',
      String(new Date().getTime()),
      '状态',
      this.alipaySignStatus ? '已签约' : '未签约',
    );

    if (platform.isAlipayMini) {
      this.alipaySignContract();
    } else {
      this.appSignContract();
    }
  }

  // app内-新旧银河签约-提现借款场景
  private appSignContract() {
    if (!this.getAlipayStatus && this.isAlipayType) {
      const params = {
        scene: SceneTypeEnum.LOAN,
        creditApplyId: this.channel.creditApplyId,
      };
      this.alipaySign(params);
    }

    if ((!this.iSalipaySignSuccess && this.commidityId === YINHE_COMMODITY)) {
      // 支付宝sdk
      signWithoutPasswordContract(alipayOptions)
        .then(async () => {
          await this.checkAlipayStatus();
        })
        .catch((e) => {
          Toast(e.response.msg);
        });
    }
  }

  // 支付宝小程序
  private async alipaySignContract() {
    if (!this.getAlipayStatus) {
      const params = {
        scene: SceneTypeEnum.LOAN,
        creditApplyId: this.channel.creditApplyId,
      };
      const paramResult = await this.alipaySignParams(params);
      paySignCenterAlipay(encodeURIComponent(paramResult.params)).then(async () => {
        await this.checkAlipay(params);
      })
        .catch((e) => {
          throw new Error(e);
        });
    }
  }


  private render() {
    return (
      <div class={style.SelectAlipay}>
        <FormField
          name="还款账户"
          isActive={!this.alipaySignStatus}
          showArrow={!this.alipaySignStatus}
          onClick={this.onSigningAlipay.bind(this)}
        >
          <div class={style.main}>
            <Icon
              name="alipay"
              class={[style.IconStyle, this.alipaySignStatus && style.signStatus]}
            />
            <span class={style.writeText}>{this.alipaySignStatus ? '已签约' : '去签约' }</span>
          </div>
          {!this.isSimplifiedListStyle && <div class={style.subText}>支付宝签约代扣</div>}
        </FormField>
      </div>
    );
  }
}
